import api from "./index";

export const createAppointment = async (payload: any) => {
  return api.post("/appointment/create-update", payload);
};

export const getAppointmentsByDate = async (date: string) => {
  return api.get(`/appointment/by-date?date=${encodeURIComponent(date)}`);
};

export const getAppointmentById = async (id: string) => {
  return api.get(`/appointment/by-id?id=${encodeURIComponent(id)}`);
};

export const deleteAppointment = async (id: string) => {
  return api.get(`/appointment/delete/${encodeURIComponent(id)}`);
};

export const getPastAppointmentsByPatient = (patientId: string) => {
  return api.get(`/appointment/allscheduleBypatientId`, {
    params: {
      patientId,
    },
  });
};


// Pagination payload & helper
export interface AppointmentPaginationPayload {
  curPage: number;
  perPage: number;
  sortBy: string;
  direction: "asc" | "desc" | string;
  whereClause: Array<{ key: string; value: string; operator: string }>;
}

export const paginateAppointments = async (
  payload: AppointmentPaginationPayload
) => {
  return api.post("/appointment/pagination", payload);
};

export interface Appointment {
  id: string;
  label: string; // display text
}